import { Toast } from '@servicetitan/design-system';
import DiagnosticsModule from '..';
import { useDiagnostics } from '../DiagnosticsContext';

const DiagnosticsToast = () => {
  const { errors } = useDiagnostics();

  const directOrPassiveErrors = errors.filter(
    (error) =>
      (error.priority === 'direct' || error.priority === 'passive') &&
      !error.read,
  );

  const handleClose = () => {
    DiagnosticsModule.markErrorsAsRead(['direct', 'passive']);
  };

  if (directOrPassiveErrors.length === 0) {
    return null;
  }

  const duration = directOrPassiveErrors.some(
    (error) => error.priority === 'direct',
  )
    ? 0
    : 3000;

  return (
    <Toast
      title='Error'
      status='critical'
      duration={duration}
      onClose={handleClose}
      primaryActionName='Dismiss'
      onPrimaryActionClick={!duration ? handleClose : undefined}
      data-testid='diagnostics-toast'
    >
      {directOrPassiveErrors.map((error) => (
        <div data-testid='diagnostics-toast-item' key={error.id}>
          {error.message}
        </div>
      ))}
    </Toast>
  );
};

export default DiagnosticsToast;

//fix write vitest for DiagnosticsToast component
